import React, { useReducer } from 'react';
import HeaderContext from './HeaderContext';
var initialState = {
  headerTheme: undefined,
  setHeaderTheme: function setHeaderTheme() {}
};
var actions = {
  SET_HEADER_THEME: 'SET_HEADER_THEME'
};

function reducer(state, action) {
  switch (action.type) {
    case actions.SET_HEADER_THEME:
      return Object.assign({}, state, {
        headerTheme: action.headerTheme
      });

    default:
      return state;
  }
}

var HeaderProvider = function HeaderProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var value = {
    headerTheme: state.headerTheme,
    setHeaderTheme: function setHeaderTheme(headerTheme) {
      dispatch({
        type: actions.SET_HEADER_THEME,
        headerTheme: headerTheme
      });
    }
  };
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: value
  }, children);
};

HeaderProvider.defaultProps = {
  children: undefined
};
export default HeaderProvider;